<template>
  <div class="footer" :style="{padding: '5px 0px', color: '#777', fontSize: '12px'}">
    <span>{{getConfig('SITE_START_YEAR')}}-{{new Date().getFullYear()}} © <a :href="getConfig('COPYRIGHT_HOLDER_HOME')||'#'" target="_blank">{{getConfig('COPYRIGHT_HOLDER')}}</a></span>
    <Divider type="vertical" />
    <span>{{getConfig('SITE_ICP_NO')}}</span>
    <Divider type="vertical" />
    <div v-if="getConfig('HOTLINE')" style="display:inline-block">
      <span>咨询电话：{{getConfig('HOTLINE')}}</span>
      <Divider type="vertical" />
    </div>
    <div v-if="getConfig('TECH_SUPPORT')" style="display:inline-block">
      <span>技术支持：<a :href="getConfig('TECH_SUPPORT_HOME')||'#'" target="_blank">{{getConfig('TECH_SUPPORT')}}</a></span>
      <Divider type="vertical" />
    </div>
    <span>建议使用Chrome/Firefox/Edge等现代浏览器</span>
  </div>
</template>

<script>
export default {
  name: 'footer',
  data () {
    return {
    }
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    }
  }
}
</script>

<style lang="less" scoped>
section {
  display: inline-block;
}
</style>